import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@NgModule({})
export class IconModule {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    const icons: string[] = [
      'copy',
      'email',
      'facebook',
      'instagram',
      'compartilhar',
      'ajudas',
      'download',
      'checklist',
      'perfil',
      'loja',
      'cupom',
      'menu',
      'notificacao',
      'perfil',
      'sair',
      'seta-baixo',
      'seta-cima',
      'tutorial',
      'vendas',
      'menu-fechar',
      'eye-see',
      'cadastro-concluido',
      'copiar-icon',
      'copiar',
      'sad',
      'smile',
      'sad-disabled',
      'smile-disabled',
      'presente',
      'extrato',
      'desafio-aceito',
      'close',
      'clock',
      'info',
      'error',
      'usuario',
      'cadeado-senha',
      'minha-loja',
      'check',
      'copiar',
      'error',
      'cea-logo',
      'menu-ponto',
      'gerar-link',
      'ic-order-down',
      'ic-consultant-white',
      'ic-consultant-black',
      'ic-home-white',
      'ic-home-black',
      'ic-shop',
      'ic-shop-white',
      'ic-shop-black',
      'ic-checklist',
      'ic-checklist-white',
      'ic-checklist-black',
      'ic-link-white',
      'ic-link-black',
      'ic-coupon-discount-white',
      'ic-coupon-discount-black',
      'ic-tutorial-white',
      'ic-tutorial-black',
      'ic-user-help-white',
      'ic-user-help-black',
      'ic-chevron-white',
      'ic-chevron-black',
      'ic-menu',
      'ic-menu-white',
      'ic-menu-black',
      'ic-logo-base',
      'ic-logo-white',
      'ic-menu-kebab',
      'ic-close-white',
      'ic-close',
      'ic-smartphone',
      'ic-smartphone-white',
      'ic-instagram',
      'ic-instagram-white',
      'ic-loterica',
      'ic-loterica-white',
      'ic-copy-gray',
      'ic-copy-pink',
      'ic-check',
      'ic-arrow-right',
      'ic-help-circle',
      'ic-help-circle-white',
      'ic-report',
      'ic-copy',
      'ic-information',
      'ic-download',
      'ic-filter',
      'ic-bag',
      'ic-bag-value-black',
      'ic-bag-value',
      'ic-calendar-check',
      'ic-package-value',
      'ic-symbol-exclamation',
      'ic-package-shop',
      'ic-package-return',
      'ic-change-cloth',
      'ic-information',
      'ic-calendar-check',
      'ic-bag-value',
      'ic-package-value',
      'ic-information',
      'ic-bag-value',
      'ic-share',
      'ic-money',
      'ic-change-cloth',
      'ic-alert-yellow',
      'ic-arrow-leftward',
      'ic-more',
      'ic-like',
      'ic-like-fill',
      'ic-sheet-blue',
      'ic-consultant-blue',
      'ic-search',
      'ic-trash-blue',
      'ic-trash-red',
      'ic-timeline-check',
      'ic-barcode',
      'ic-camera',
      'ic-flag',
      'folha',
      'ic-right',
      'ic-left',
      'ic-close-modal',
      'ic-left-modal',
      'ic-close-options',
      'ic-scan-barcode',
      'ic-hist-report',
      'ic-logo-base-2024',
      'ic-loan-white'
    ];

    icons.forEach((e) => {
      this.matIconRegistry.addSvgIcon(
        e,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/${e}.svg`)
      );
    });
  }
}
